<template>
  <div class="feedBack">
    <headers class="herderNav" ref="header" :isChange="false"/>
    <div class="feefContent">
      <!-- 导航 -->
      <div class="conNav">
        <div class="navText">
          <h2>反馈中心</h2>
          <p>无论是网站的疑问、对备考的建议或错误您都可以通过提交反馈与我们联系，我们将尽快回应您。</p>
        </div>
        <div class="navImg">
          <img src="@/assets/onlinePractice/navRightIcon.png" alt="" />
        </div>
      </div>
      <!-- 内容 -->
      <div class="conContent">
        <h2>提交反馈</h2>
        <div class="conTexts">
          <div class="conLefts">
            <div class="matterType conLeftsFirst">
              <div class="matterTit">问题类型</div>
              <div class="leftTextTit">
                <div class="leftBtns" v-for="(ele, index) in errTypeBtns" :key="index" :class="n == index ? 'errTypeBtns' : ''" @click="switchErr(index)">{{ ele }}</div>
              </div>
            </div>
            <div class="matterType">
              <div class="matterTit">具体描述</div>
              <div class="leftTextTit">
                <div class="leftBtns" v-for="(item, indexs) in describe" :key="indexs" :class="m == item.type ? 'errTypeBtns' : ''" @click="switchContact(item.type,item)">{{ item.name }}</div>
                <textarea class="textArea" v-model="feedBack.description" name="" id="" rows="8" placeholder="请描述问题详情"></textarea>
              </div>
            </div>
            <div class="matterType">
              <div class="matterTit">上传图片</div>
              <div class="" style="">
                <el-upload class="avatar-uploader" action="https://www.scoreupup.com/index/user/avatar" :show-file-list="false" :on-success="handleAvatarSuccess" :limit="5" name="avatar">
                  <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </div>
            <input class="inputNum" type="text" placeholder="输入电话号码" v-model="feedBack.phone"/>
            <el-button class="submitBtn" @click="defineInfo">提交</el-button>
          </div>
          <div class="conRights">
            <div class="conRightText">
              <p>我们一共收到了50000+条反馈并进行了相应的处理</p>
              <p>感谢您对考满分的关注，我们会认</p>
              <p>真查看并思考每一条反馈，</p>
              <p>并承诺在最快时间内回复各位。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import api from "@/api/personallnfo.js";
export default {
  components: {
    headers,
  },
  data() {
    return {
      navCodes: require("@/assets/login/navCode.png"),
      herderTits: {
        color: "#666666",
      },
      headerBack: { background: "#ffffff" },
      headerIcon: require("@/assets/home/headerNav.png"),
      n: null,
      //问题类型
      errTypeBtns: [],
      m: null,
      //具体描述
      describe: [
        { name: "可以联系我", type: 1 },
        { name: "不需要联系", type: 2 },
      ],
      imageUrl: '',
      feedBack:{
        type:'',
        phone:'',
        description:'',
        is_call:''
      }
    };
  },
  mounted() {
    this.$refs.header.isTop=false
    this.$refs.header.headerBack.background = '#ffffff';
    this.$refs.header.herderTits.color = '#666666';
    this.$refs.header.headerIcon = require('@/assets/home/headerNav.png');
    this.$refs.header.loginButton = {
       background : '#618aff',
       color:'#fff'
    }
    this.$refs.header.phoneButton = {
    color:'#618aff',
    border: '1px solid #618aff'
     }
    this.getType();
  },
  methods: {
    switchErr(index) {
      this.n = index;
      this.feedBack.type = index + 1;
    },
    switchContact(type,item) {
      this.m = type;
      if(type == 1){
        this.feedBack.is_call = item.name
      }else{
        this.feedBack.is_call = item.name
      }
    },
     handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      defineInfo(){
        console.log(this.feedBack)
        if(!this.feedBack.description){
          this.$message.error('描述信息不能为空')
        }else{
          if(this.feedBack.phone){
            const telStr = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/;
            if(!(telStr.test(this.feedBack.phone))){
               this.$message.error('手机格式错误')
            }
          }
          this.m = this.n = null
          this.addType()
        }
      },
    //获取反馈类型
    getType() {
      api.getType().then((res) => {
        this.errTypeBtns = res.data.data;
      });
    },
    //新增类型
    addType(){
      let query = this.$qs.stringify(this.feedBack)
      api.addFeedback(query).then(res =>  {
        this.$message.success('提交成功');
        for(let key in this.feedBack){
          this.feedBack[key] = ''
        }
      })
      .catch(err  => {
        this.$message.error('提交失败')
      })
    }
  },
};
</script>

<style scoped>
@import url("../../assets/css/feedBack.css");
</style>



// WEBPACK FOOTER //
// src/view/questionBank/feedback.vue